export const LOADING_SECTION_INFO = "LOADING_SECTION_INFO";
export const UPDATE_SECTION_INFO_SUCCESS = "UPDATE_SECTION_INFO_SUCCESS";
export const UPDATE_SECTION_INFO_FAILED = "UPDATE_SECTION_INFO_FAILED";
